import { extend } from 'vee-validate'
import { required, email, max, max_value, min, min_value, is, is_not, oneOf, regex, confirmed} from "vee-validate/dist/rules";

extend('required', required);
extend('email', email);
extend('max', max);
extend('max_value', max_value);
extend('min', min);
extend('min_value', min_value);
extend('is', is);
extend('is_not', is_not);
extend('oneOf', oneOf);
extend('regex', regex);
extend('confirmed', confirmed);

extend('fraud', {
    params: ['fraud'],
    validate: value => {

        if(_.size(value) <= 1) {
            return false;
        }

        //CHECK CONSUME+VOWEL
        let vowels = ['a','e','i','o','u','y'];
        let vowelsUpp = _.map(vowels, val => _.toUpper(val));
        let consumes = ['b','c','d','f','g','h','j','k','l','m','n','p','q','r','s','t','v','w','x','z'];
        let consumesUpp = _.map(consumes, val => _.toUpper(val));
        let checkVowels = _.some(vowels,(el) => _.includes(value, el)) || _.some(vowelsUpp,(el) => _.includes(value, el))
        let checkConsumes = _.some(consumes,(el) => _.includes(value, el)) || _.some(consumesUpp,(el) => _.includes(value, el))

        if(!(checkVowels && checkConsumes)){
            return false
        }


        //CHECK SPECIALS CHARACTERS
        let acceptedChar=[...vowels,...vowelsUpp,...consumes,...consumesUpp,'.',' ','À','Á','Â','Ã','Ä','Å','Æ','Ç','È','É','Ê','Ë','Ì','Í','Î','Ï','Ð','Ñ','Ò','Ó','Ô','Õ','Ö','Ø','Œ','Š','þ','Ù','Ú','Û','Ü','Ý','Ÿ','à','á','â','ã','ä','å','æ','ç','è','é','ê','ë','ì','í','î','ï','ð','ñ','ò','ó','ô','õ','ö','ø','œ','š','Þ','ù','ú','û','ü','ý','ÿ']
        let failAcceptedChar = false;
        _.some(value,(el)=>{
            if(!_.includes(acceptedChar,el)){
                failAcceptedChar = true;
            }
        })
        if(failAcceptedChar){
            return false;
        }

        // CHECK REPEAT 3 CHARACTERS
        let failRepeat3 = false;
         _.forEach(value, (letter,index)=>{
            let char1=_.toLower(letter);
            let char2=_.toLower(_.get(value,index+1));
            let char3=_.toLower(_.get(value,index+2));

            if(char1==char2 && char1==char3){
                // console.log('REPEAT 3')
                failRepeat3 = true;
            }
        })

        if(failRepeat3){
            return false;
        }

        //CHECK LENGTH <30
        if(_.size(value)>30){
            return false
        }

        return true;
    }
})
require('./antifraud');
require('./date');
